import React, { useState, useRef, useEffect } from "react";
import ClientNavbar from "../layout/ClientNavbar";
import { NavLink } from "react-router-dom";

const TEAL = "#06b6a4";

const SUB_CATEGORIES = [
  "Commodity: Gold",
  "Commodity: Gold & Silver",
  "Commodity: Silver",
  "Debt: Banking and PSU",
  "Debt: Corporate Bond",
  "Debt: Credit Risk",
  "Debt: Dynamic Bond",
  "Debt: Fixed Income",
  "Hybrid: Arbitrage",
  "Hybrid: Balanced Advantage",
  "Others: FoFs Domestic",
  "Solution: Children Equity",
];

const TABLE_HEADERS = [
  { key: "scheme", label: "Scheme", sort: true, search: true },
  { key: "subCategory", label: "Sub Category", sort: true, search: false },
  { key: "minLumpsum", label: "Min Lumpsum Amount", sort: true, search: false },
  { key: "minSip", label: "Min Monthly SIP Amount", sort: true, search: false },
  { key: "y1", label: "1 Years", sort: true, search: false },
  { key: "y3", label: "3 Years", sort: true, search: false },
  { key: "y5", label: "5 Years", sort: true, search: false },
];

const inputStyle = {
  borderRadius: "8px",
  border: "1px solid #cbd5e1",
  padding: "8px 12px",
  fontSize: "14px",
  width: "100%",
  background: "#fff",
};

export default function FundPicks() {
  const [subCategorySearch, setSubCategorySearch] = useState("");
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const filteredCategories = SUB_CATEGORIES.filter((c) =>
    c.toLowerCase().includes((subCategorySearch || "").toLowerCase())
  );

  useEffect(() => {
    function handleClickOutside(e) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const displayValue = selectedSubCategory || "Select Sub Category";

  return (
    <>
      <ClientNavbar />
      <div className="page-content" style={{ background: "#f1f5f9", minHeight: "100vh" }}>
        {/* Header */}
        <div className="card shadow-sm border-0 mb-4" style={{ borderRadius: "12px" }}>
          <div className="card-body p-4">
            <h3 className="text-primary mb-2">Fund Picks</h3>
            <nav aria-label="breadcrumb" style={{ "--bs-breadcrumb-divider": "none" }}>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <NavLink to="/overview">Dashboard</NavLink> /
                </li>
                <li className="breadcrumb-item">
                  <span style={{ color: "#64748b" }}>Invest Online BSE</span> /
                </li>
                <li className="breadcrumb-item active" aria-current="page">Fund Picks</li>
              </ol>
            </nav>
          </div>
        </div>

        {/* Sub Category filter */}
        <div className="card shadow-sm border-0 mb-4" style={{ borderRadius: "12px", border: "1px solid #e2e8f0", overflow: "visible" }}>
          <div className="card-body p-4" style={{ overflow: "visible" }}>
            <div className="row align-items-end" style={{ overflow: "visible" }}>
              <div className="col-md-4" ref={dropdownRef} style={{ overflow: "visible" }}>
                <label className="form-label small text-muted mb-1">Sub Category</label>
                <div style={{ position: "relative", overflow: "visible" }}>
                  <div
                    role="button"
                    tabIndex={0}
                    onClick={() => setDropdownOpen(!dropdownOpen)}
                    onKeyDown={(e) => e.key === "Enter" && setDropdownOpen(!dropdownOpen)}
                    style={{ ...inputStyle, display: "flex", alignItems: "center", cursor: "pointer" }}
                  >
                    <span className="d-flex align-items-center px-2" style={{ color: "#64748b" }}>
                      <i className="fa fa-filter" aria-hidden />
                    </span>
                    <span className="flex-grow-1" style={{ color: displayValue.startsWith("Select") ? "#94a3b8" : "#334155" }}>
                      {displayValue}
                    </span>
                    <i className={`fa fa-chevron-${dropdownOpen ? "up" : "down"} px-2`} style={{ color: "#64748b" }} aria-hidden />
                  </div>
                  {dropdownOpen && (
                    <div
                      onMouseDown={(e) => e.stopPropagation()}
                      style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        marginTop: 4,
                        background: "#fff",
                        border: "1px solid #e2e8f0",
                        borderRadius: "8px",
                        boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
                        zIndex: 1050,
                        maxHeight: 280,
                        overflow: "hidden",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <input
                        type="text"
                        className="form-control border-0 rounded-0"
                        placeholder="Type to Search..."
                        value={subCategorySearch}
                        onChange={(e) => setSubCategorySearch(e.target.value)}
                        onMouseDown={(e) => e.stopPropagation()}
                        onClick={(e) => e.stopPropagation()}
                        style={{ padding: "10px 12px", borderBottom: "1px solid #e2e8f0" }}
                      />
                      <div style={{ overflowY: "auto", maxHeight: 220 }}>
                        {filteredCategories.map((item) => (
                          <div
                            key={item}
                            role="button"
                            tabIndex={0}
                            onClick={() => {
                              setSelectedSubCategory(item);
                              setDropdownOpen(false);
                              setSubCategorySearch("");
                            }}
                            onKeyDown={(e) => e.key === "Enter" && (setSelectedSubCategory(item), setDropdownOpen(false), setSubCategorySearch(""))}
                            style={{
                              padding: "10px 12px",
                              cursor: "pointer",
                              fontSize: "14px",
                              color: "#334155",
                              borderBottom: "1px solid #f1f5f9",
                            }}
                            className="fund-picks-category-item"
                          >
                            {item}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
       

        {/* Fund Picks table */}
      
          <div className="table-responsive mt-3">
            <table className="table table-hover mb-0">
              <thead style={{ background: "#f8fafc" }}>
                <tr>
                  {TABLE_HEADERS.map((h) => (
                    <th
                      key={h.key}
                      style={{
                        padding: "12px 16px",
                        color: h.key === "scheme" ? TEAL : "#475569",
                        fontWeight: "600",
                        fontSize: "13px",
                        whiteSpace: "nowrap",
                        borderBottom: h.key === "scheme" ? `2px solid ${TEAL}` : "1px solid #e2e8f0",
                        background: h.key === "scheme" ? "rgba(6, 182, 164, 0.08)" : undefined,
                      }}
                    >
                      {h.label}
                      {h.sort && (
                        <i className="fa fa-sort ms-1 opacity-75" style={{ fontSize: "10px" }} aria-hidden />
                      )}
                      {h.search && (
                        <i className="fa fa-search ms-1 opacity-75" style={{ fontSize: "10px" }} aria-hidden />
                      )}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody style={{ background: "#fff", minHeight: 200 }}>
                <tr>
                  <td colSpan={7} className="text-center py-5">
                    <div className="d-flex flex-column align-items-center justify-content-center text-muted">
                      <i className="fa fa-exclamation-triangle mb-2" style={{ fontSize: "28px", color: "#f59e0b" }} aria-hidden />
                      <span style={{ fontSize: "15px" }}>No data available.</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <style>{`
        .fund-picks-category-item:hover { background: #ecfdf5 !important; color: #0d9488 !important; }
      `}</style>
    </>
  );
}
